import React from 'react'
import { Box } from '../Styled'
import { Link } from 'react-router-dom'
import { CustomerAddress } from 'lib/types/core'
import { FormattedMessage } from 'react-intl'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { useDirectoryOptions } from 'lib/core/hooks'

interface Props {
  address: CustomerAddress
  paymentMethod: any
  label: string
}

export const DefaultPayment: React.FC<Props> = ({ address, paymentMethod, label }) => {
  const {
    city,
    countryCode,
    firstName,
    lastName,
    postalCode,
    regionCode,
    street
  } = address

  const {
    countryInfoOptions
  } = useDirectoryOptions({ countryCode })

  const countryOption = countryInfoOptions.find(infoOption => { return infoOption.value === countryCode })

  return (
    <Box>
      <FlexWrapper className='flex-box'>
        <h3><FormattedMessage id={label} /></h3>
        <Link to='/customer/account/addresses' className='toRight'>
          <FormattedMessage id='customer.account.dashboard.edit' />
        </Link>
      </FlexWrapper>
      <div className='border-box'>
        <p>{firstName} {lastName}</p>
        <p>{street}</p>
        <p>{city}, {regionCode}, {postalCode}</p>
        <p>{countryOption?.label}</p>
      </div>
    </Box>
  )
}
